import { Button } from "@msuite/ui/button";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { toast } from "@msuite/ui/toast";
import { FormProvider, useForm } from "react-hook-form";
import { SuggestBetterTranslationForm } from "@/forms/suggest-better-translation-form";

export function SuggestBetterTranslationModal(props: ModalProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm();

	/** Functions */
	async function handleOnSubmit() {
		// submit
		toast.success("Posted");
		handleOnClose();
	}

	function handleOnClose() {
		props.onClose();
		methods.reset();
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<Modal
				isOpen={props.isOpen}
				onClose={props.onClose}
				title={t("localization.suggest_better_translation")}
				onSubmit={methods.handleSubmit(handleOnSubmit)}
			>
				<Modal.Body>
					<SuggestBetterTranslationForm />
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="ghost"
						onClick={props.onClose}
					>
						{t("general.cancel")}
					</Button>
					<Button
						variant="primary"
						type="submit"
					>
						{t("general.submit")}
					</Button>
				</Modal.Footer>
			</Modal>
		</FormProvider>
	);
}
